import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import PlantMilkProduct from 'models/PlantMilkProduct'
import PlantMilkNutrition from './PlantMilkNutrition'
import PlantMilkPackage from './PlantMilkPackage'

const productOptions = {
  nutritionInfo: <PlantMilkNutrition />,
  packagingInfo: <PlantMilkPackage />,
  productTitle: 'Brand Specific Plant-Based Milk Alternatives',
  model: PlantMilkProduct,
  validCategories: ['52', '55'],
  validSubCategories: ['011', '001', '002', '003', '004', '005', '006', '007', '008'],
  validProductTypes: [
    '52/011',
    '55/001',
    '55/002',
    '55/003',
    '55/004',
    '55/005',
    '55/006',
    '55/007',
    '55/008',
  ],
  brandSpecific: true,
}

const PlantMilk = () => <ProductForm product={productOptions} />

export default PlantMilk
